import { isDef as i, inBrowser as e } from "../index.js";
import { isNumeric as o } from "../validate/number.js";
function g(n) {
  if (i(n)) return n = String(n), o(n) ? n + "px" : n;
}
var r;
function f() {
  if (!r) {
    var n = document.documentElement,
      t = n.style.fontSize || window.getComputedStyle(n).fontSize;
    r = parseFloat(t);
  }
  return r;
}
function c(n) {
  return n = n.replace(/rem/g, ""), +n * f();
}
function d(n) {
  return n = n.replace(/vw/g, ""), +n * window.innerWidth / 100;
}
function m(n) {
  return n = n.replace(/vh/g, ""), +n * window.innerHeight / 100;
}
function s(n) {
  if (typeof n == "number") return n;
  if (e) {
    if (n.indexOf("rem") !== -1) return c(n);
    if (n.indexOf("vw") !== -1) return d(n);
    if (n.indexOf("vh") !== -1) return m(n);
  }
  return parseFloat(n);
}
export { g as addUnit, s as unitToPx };
